export const TemperatureAtTarget = () => (
  <svg width="57" height="48" viewBox="0 0 38 33" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        d="M24.64 14.357 28 4.501l-.56-.137c-.64-.157-1.82-.083-2.8.846V.693h-.533c-1.767 0-3.205 1.405-3.205 3.134v1.52L17.92 0l-.46.225c-.603.295-1.07.874-1.315 1.632-.314.97-.22 2.059.25 2.913l1.48 2.713h-3.603L10 11.66l.378.37c.332.325.671.542 1.006.677l-.095-.002h-.534v4.917L16.252 23l.756-.739-5.185-5.07V13.82c.634.146 1.603.601 1.603 2.021v.262l2.652 1.945 3.756-2.45V12.49l-2.449-2.395h-2.578l-1.223 1.195c-.111.107-1.014.917-2.03.329l3.16-3.091h3.846l5.013 4.457v7.25L26.399 23l.755-.739-2.513-2.458v-5.446zm-10.303-2.326.912-.892h1.693l1.824 1.783v2.116l-2.652 1.73-1.629-1.195c-.103-1.605-1.133-2.376-2.104-2.689.84-.027 1.565-.471 1.956-.853zm12.244-6.67-2.005 6.143.065-4.44c.556-1.287 1.379-1.631 1.94-1.703zm-4.61-1.535c0-.971.68-1.79 1.601-2.023l.06 8.624-1.662-3.165V3.826zm-4.808-1.653c.088-.274.214-.507.368-.689l5.49 9.674-3.827-3.479-1.858-3.403c-.332-.603-.398-1.409-.173-2.103z"
        fill="#2396FD"
        fillRule="nonzero"
      />
      <text fontFamily="Roboto Flex" fontSize="7.1" fill="#7F7F7F">
        <tspan x="6.152" y="31">
          at target
        </tspan>
      </text>
    </g>
  </svg>
);
